import { version } from '../../../../package.json';

export const envs = {
  version: version,
  apiUrl: import.meta.env.APP_ENV_API_URL,
  wsUrl: import.meta.env.APP_ENV_WS_URL,
  sentryDsn: import.meta.env.APP_ENV_SENTRY_DSN,
  xProduct: import.meta.env.APP_ENV_X_PRODUCT,
  mediaUrl: import.meta.env.APP_ENV_MEDIA_URL,
  appUrl: import.meta.env.APP_ENV_APP_URL,
  posthogKey: import.meta.env.APP_ENV_POSTHOG_KEY,
  posthogHost: import.meta.env.APP_ENV_POSTHOG_HOST,
};
